import { render, staticRenderFns } from "./headerBar.vue?vue&type=template&id=4b560794&scoped=true&"
import script from "./headerBar.vue?vue&type=script&lang=ts&"
export * from "./headerBar.vue?vue&type=script&lang=ts&"
import style0 from "./headerBar.vue?vue&type=style&index=0&id=4b560794&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b560794",
  null
  
)

export default component.exports